/* eslint-disable import/prefer-default-export */
import AndroidIcon from './android';
import AppsIcon from './apps';
import CompareIcon from './compare';
import ForumIcon from './forum';
import InfoIcon from './info';
import IosIcon from './ios';
import ListsIcon from './lists';
import MemberIcon from './member';
import MinhembioIcon from './minhembio';
import PricefightIcon from './pricefight';
import ShopsIcon from './shops';

export {
  AndroidIcon,
  AppsIcon,
  CompareIcon,
  ForumIcon,
  InfoIcon,
  IosIcon,
  ListsIcon,
  MemberIcon,
  MinhembioIcon,
  PricefightIcon,
  ShopsIcon,
};
